// APP Version
export const APP_VERSION = process.env.REACT_APP_VERSION

// API URL
export const API_URL = process.env.REACT_APP_API_URL

// Image Hosting
export const IMAGES_DOMAIN = process.env.REACT_APP_IMAGE_DOMAIN

// Google Maps Services
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY
export const GOOGLE_MAPS_ID = process.env.REACT_APP_GOOGLE_MAPS_ID
export const GOOGLE_PLACES_LIBRARY = ['maps', 'places', 'marker', 'geocoding']
export const MARKER_CLUSTER_MAX_ZOOM = 16
export const FOCUSED_LOCATION_ZOOM = MARKER_CLUSTER_MAX_ZOOM + 1

// Localization Services
export const LOCIZE_API_KEY = process.env.REACT_APP_LOCIZE_API_KEY
export const LOCIZE_PROJECT_ID = process.env.REACT_APP_LOCIZE_PROJECT_ID

// Deployment / observability (Datadog RUM env tag)
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT

// Practice dashboard login, served from the same host as the API
const apiOrigin = (() => {
  try {
    return new URL(API_URL).origin
  } catch {
    return 'https://app.intelibly.com'
  }
})()

export const PRACTICE_LOGIN_URL =
  process.env.REACT_APP_PRACTICE_LOGIN_URL || `${apiOrigin}/login`

// PARTNER URLS
export const CARE_CREDIT_URL = process.env.CARE_CREDIT_URL
